var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconDisability40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_17134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2311 32.2594V17.6294C29.2311 15.8578 27.7881 14.4216 26.0081 14.4216H13.8257",
    stroke: "#1E1E1E",
    strokeWidth: 1.1,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.52881 5.50269H13.8261V21.5331",
    stroke: "#1E1E1E",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8799 23.3406H33.2853C33.7331 23.3406 34.0961 23.7036 34.0961 24.1514V25.773C34.0961 26.2208 33.7331 26.5838 33.2853 26.5838H17.8799V23.3406Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2314 35.5533C30.7987 35.5533 32.0692 34.2828 32.0692 32.7155C32.0692 31.1482 30.7987 29.8777 29.2314 29.8777C27.6641 29.8777 26.3936 31.1482 26.3936 32.7155C26.3936 34.2828 27.6641 35.5533 29.2314 35.5533Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7163 35.5027C17.6859 35.5027 20.9038 32.2847 20.9038 28.3152C20.9038 24.3456 17.6859 21.1277 13.7163 21.1277C9.74676 21.1277 6.52881 24.3456 6.52881 28.3152C6.52881 32.2847 9.74676 35.5027 13.7163 35.5027Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_17134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconDisability40);
export default __webpack_public_path__ + "static/media/pictogramBeaconDisability40.1cd6e62095bb1bfa721b80f1e02299fb.svg";
export { ForwardRef as ReactComponent };